import { useQuery } from '@tanstack/react-query';

import * as api from 'apis/merchant-onboarding-service/api';

export const useUserContracts = () => {
  const { data: userContracts = [], isLoading: isLoadingContracts } = useQuery(['me/contracts'], () =>
    api.getUserContractDetails(),
  );

  return { userContracts, isLoadingContracts };
};
